import { storeUserName } from "@/services/user/userService";
import {
  SET_USER,
  SET_KEYCLOAK,
  LOGOUT,
  SET_USER_CONTRACTS,
  SET_USER_PERMISSIONS,
  SET_UN_CONSTRUCTED_USER_PERMISSIONS
} from "@/store/user/mutation-types";
const mutations = {
  /**
   * Set current module
   * @param state
   * @constructor
   */
  [SET_USER]: state => {
    const userName =
      state?.keycloak && state?.keycloak?.idTokenParsed
        ? state?.keycloak?.idTokenParsed?.preferred_username || null
        : null;

    state.user = userName;
    storeUserName(userName);
  },
  [SET_KEYCLOAK]: (state, payload) => {
    state.keycloak = payload;
  },
  [LOGOUT]: state => {
    try {
      state.user = null;
      state?.keycloak?.logout();
    } catch (error) {
      console.error(error);
    }
  },
  [SET_USER_CONTRACTS]: (state, payload) => {
    state["userContracts"] = payload || [];
  },
  [SET_USER_PERMISSIONS]: (state, payload) => {
    state["userPermissions"] = payload || [];
  },
  [SET_UN_CONSTRUCTED_USER_PERMISSIONS]: (state, payload) => {
    state["unConstructedUserPermissions"] = payload || [];
  }
};

export default mutations;
